function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "evenodd"
}, React.createElement("path", {
  fillRule: "nonzero",
  d: "M17 13.25c-2.07 0-3.75 1.68-3.75 3.75v6c0 2.07 1.68 3.75 3.75 3.75h6c2.07 0 3.75-1.68 3.75-3.75v-6c0-2.07-1.68-3.75-3.75-3.75h-6zm7.5 1.5a.75.75 0 110 1.5.75.75 0 010-1.5zm-4.5 1.5c2.07 0 3.75 1.68 3.75 3.75 0 2.07-1.68 3.75-3.75 3.75-2.07 0-3.75-1.68-3.75-3.75 0-2.07 1.68-3.75 3.75-3.75zm0 1.5a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z"
}), React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 19.5,
  stroke: "#FFF",
  fill: "none"
}));

function SvgIginline(props) {
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, props), _ref);
}

export default SvgIginline;